import React from "react";
import "./Errorsummery.scss";

const fieldLabels: Record<string, string> = {
  brand_name: "Brand Name",
  brand_country: "Country",
};

interface ErrorSummaryProps {
  errors: Record<string, string>;
}

const ErrorSummary = ({ errors }: ErrorSummaryProps) => {
  const errorEntries = Object.entries(errors);

  if (!errorEntries.length) return null;

  return (
    <>
      <div className="error-summary form-error">
        <div className="error-header">
          <span className="error-icon">!</span>
          <span>Form Errors</span>
        </div>
        <div className="error-message">
          Please fix the following errors to submit the form
        </div>
      </div>
      <div>
        <ul className="error-list">
          {errorEntries.map(([field, message]) => (
            <li key={field}>
              <strong>{fieldLabels[field] || field}:</strong> {message}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ErrorSummary;